<pose-viewer
  #poseViewer
  autoplay="true"
  aspect-ratio="1"
  [attr.background]="background"
  [attr.src]="src"
  width="100%"></pose-viewer>
